import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import ScheduleCalendar from '../components/ScheduleCalendar';
import { useCenterSchedule } from '../contexts/CenterScheduleContext';

const CenterSchedule: React.FC = () => {
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const { schedules, loading, fetchSchedulesByMonth } = useCenterSchedule();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const year = currentMonth.getFullYear();
    const month = currentMonth.getMonth() + 1;
    fetchSchedulesByMonth(year, month);
  }, [currentMonth, fetchSchedulesByMonth]);

  return (
    <>
      <SEO
        title="센터 일정안내"
        description="동두천시 글로벌인재교육센터 월별 일정을 확인하세요."
        keywords="동두천글로벌인재교육센터, 센터일정, 휴관일, 교육일정"
        path="/application/schedule"
      />
      <div className="min-h-screen flex flex-col">
        <Header />

        {/* Page Header */}
        <div className="relative text-white py-12 sm:py-16 md:py-20 lg:py-24 mt-20 overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://images.unsplash.com/photo-1506784983877-45594efa4cbe?w=1920&h=600&fit=crop&q=80"
              alt="센터 일정안내"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-black/50"></div>
          </div>

          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
            <p className="text-gray-200 mb-2 sm:mb-3 text-xs sm:text-sm font-medium tracking-wider">수강신청</p>
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-3 sm:mb-4">센터 일정안내</h1>
            <div className="w-16 sm:w-20 h-1 bg-white/70"></div>
          </div>
        </div>

        {/* Content */}
        <div className="flex-1 py-8 sm:py-12 bg-gray-50">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <p className="text-center text-gray-600 mb-2 text-sm sm:text-base">
              센터의 월별 일정을 확인하실 수 있습니다. 휴관일 및 주요 행사 일정을 참고해 주세요.
            </p>
            <p className="text-center text-gray-800 mb-6 text-sm sm:text-base font-medium">
              날짜를 클릭하면 세부내역을 볼 수 있습니다
            </p>
            <ScheduleCalendar
              currentMonth={currentMonth}
              onMonthChange={setCurrentMonth}
              schedules={schedules}
              loading={loading}
            />
          </div>
        </div>

        <Footer />
      </div>
    </>
  );
};

export default CenterSchedule;
